import { connect } from 'react-redux';

import TrafficSourceComponent from '../components/pages/trafficSource/TrafficSource';

export default connect()(TrafficSourceComponent);
